import React, { useRef, useEffect } from 'react';
import style from './dialogs-list.module.scss';
import AddIcon from '../../../../../../../assets/svg/solo-chat/circle-plus.svg';
import EventIcon from '../../../../../../../assets/svg/solo-chat/dialog-event.svg';
import IntentIcon from '../../../../../../../assets/svg/solo-chat/dialog-intent.svg';
import { Link } from 'react-router-dom';
import { useAppAndBranchId, usePrevious, usePermissions } from '../../../hooks';
import { DialogGroup } from '../types';
import { Icon, Spin } from 'antd'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../../stateManager/store';

type Props = {
  dialogGroups: DialogGroup[];
  selectedDialog: string;
  openDialog: (dialog: string) => void;
  loading: boolean
  dialogCount: number;
};

export function DialogsList(props: Props) {
  const { dialogGroups, selectedDialog, openDialog, loading, dialogCount } = props 
  const [appId] = useAppAndBranchId()
  const isDefaultSelectedRef = useRef(false)
  const [, branchId] = useAppAndBranchId()
  const prevBranchId = usePrevious(branchId)
  const canCreate = usePermissions('dialog.Create')
  const locationState = useLocation().state as Record<string, string> | undefined
  const { selectedApp: {chatType} } = useSelector((state: RootState) => state.apps)

  // on mount, select the first dialog group by default or
  // if the user is redirected from creating/editing a dialog, select that dialog
  useEffect(() => {
    if(!isDefaultSelectedRef.current && Array.isArray(dialogGroups) && dialogGroups.length) {
      let dialog = dialogGroups[0]
      if(locationState?.dialog) {
        const [value, type] = locationState.dialog.split(":")
        const redirectedDialog = dialogGroups.find(group => group.dialogType === type && group.dialogValue === value)
        if(redirectedDialog) {
          dialog = redirectedDialog
        }
      }
      openDialog(`${dialog.dialogValue}:${dialog.dialogType}`)
      isDefaultSelectedRef.current = true
    }
  }, [dialogGroups])

	// reset local state whenever a new branch is selected
	useEffect(() => {
	  if(branchId && prevBranchId !== branchId) {
		  isDefaultSelectedRef.current = false
		}
	}, [branchId])

  return (
    <div className={style.dialogsList}>
      {canCreate &&
        <Link to={`/apps/list/${appId}/solo/${chatType === 'genai' ? 'events' : 'qna'}/dialog/create`} className={style.add}>
          <img src={AddIcon} alt="add dialogs" />
          <span>Add {chatType === 'genai' ? 'Events' : 'Dialogs'}</span>
        </Link>
      }

      {loading && (
        <Spin indicator={<Icon type="loading" style={{ fontSize: 24, marginTop: '1rem', marginLeft: '4rem', color: '#15808C' }} spin />} />
      )}

      <div className={style.dialogs}>
        {!loading && [...dialogGroups]
          .sort((a, b) => {
            if (a.dialogType === "event" && b.dialogType !== "event") return -1;
            if (a.dialogType !== "event" && b.dialogType === "event") return 1;
            return a.dialogValue.localeCompare(b.dialogValue);
          }).map((dialog) => {
            return (
            <button onClick={() => {
              openDialog(`${dialog.dialogValue}:${dialog.dialogType}`)
            }} data-selected={`${dialog.dialogValue}:${dialog.dialogType}` === selectedDialog} key={dialog.dialogValue} className={style.dialog}>
              <span className="text-ellipsis" title={dialog.dialogValue}>{dialog.dialogValue}</span>
              <div className='flex gap-2 align-center'>
                { `${dialog.dialogValue}:${dialog.dialogType}` === selectedDialog ? 
                  <span className= {style.dialogCount}>
                    { dialogCount || 0 }
                  </span> 
                : 
                  null }
                <img src={dialog.dialogType === "event" ? EventIcon : IntentIcon} alt="dialog type" />
              </div>
            </button>
          )
        })}
      </div>
    </div>
  )
}
